<template>
  <div class="page">
    <navigation>{{ pageTitle }}</navigation>
    <section class="content">
      <div class="tips">
        温馨提示：仅支持提现至本人储蓄银行账户，提交成功后，现金
        红包会在5个工作日内到账
      </div>
      <form class="form" ref="form">
        <div class="form-item">
          <div class="label">持卡人</div>
          <nd-input :value="userInfo.name" readonly placeholder="" />
        </div>

        <div class="form-item underline-un-focus">
          <div class="label">银行卡</div>
          <nd-input
            v-model="form.bankcardNo"
            name="bankcardNo"
            type="pure-number"
            placeholder="请提供境内储蓄银行卡号"
            :disabled="!isModify"
          >
          </nd-input>
        </div>

        <div
          class="form-item underline-un-focus"
          :class="{ modify: isUpdateMode }"
        >
          <div class="label">手机号</div>
          <nd-input
            v-model="form.bankMobile"
            name="bankMobile"
            :readonly="!isUpdateModePhone"
            type="pure-number"
            maxLength="11"
            placeholder="请输入银行卡绑定的手机号"
            ref="mobile"
          >
          </nd-input>
          <span
            v-if="isUpdateMode"
            class="modify-append"
            @click="modifyMobile"
          >修改</span>
        </div>
      </form>
      <div class="support" @click="supportBank">
        <img
          src="../bankcard/images/icon_chakan.png"
          srcset="
                        ../bankcard/images/icon_chakan@2x.png 2x,
                        ../bankcard/images/icon_chakan@3x.png 3x
                    "
        />查看支持的银行卡列表
      </div>
    </section>

    <nd-sms
      :duration="duration"
      :showMobile="false"
      :tips="smsTips"
      v-model="smsVisible"
      @retrieve="sendSmsAgain"
      @confirm="confirmBind"
      :errorTip="errorTip"
      @countEnd="countEnd"
      @close="closeSms"
    ></nd-sms>

    <nd-button class="btn" :disabled="isDisabled" @click="next">红包提现到银行卡</nd-button>
  </div>
</template>
<script>
import validate from '../../components/nd-validate'
import NdSms from '@/view/bankcard/components/nd-sms'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'bankcard-add',

  mixins: [validate],

  customReadyNotify: true,

  components: {
    NdSms
  },

  data () {
    return {
      form: {
        bankMobile: '',
        bankcardNo: ''
      },
      rules: {
        bankMobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        bankcardNo: [
          {
            require: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          },
          {
            regular: /^\d{8,28}$/,
            message: '请输入正确的银行卡号',
            trigger: 'blur'
          }
        ]
      },
      isDisabled: true,
      isUpdateMode: false, // 是否为换绑银行卡
      isUpdateModePhone: true,
      isModify: true, // 是否可以修改银行卡
      pageTitle: '',
      smsVisible: false,
      loanPlatform: this.$route.query.loanPlatform || 'TMD',
      fundCode: this.$route.query.fundCode || 'ndmicro',
      smsKey: '',
      errorTip: '',
      showMobile: '',
      duration: 120,
      canSendSms: true,
      bankMobile: '',
      couponRecordId: this.$route.query.couponRecordId,
      plan: this.$route.query.plan
    }
  },

  async created () {
    try {
      await Promise.all([
        this.getUserInfoX({ forceUpdate: true }),
        this.getBankCardList()
      ])
      this.$nextTick(() => {
        this.form.bankcardNo = this.defaultBankcard.bankCardNo
        this.form.bankMobile =
          this.defaultBankcard.bankMobile || this.userInfo.mobile
      })
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    ...mapState('bankcard', {
      bankcardList: (state) => state.bankcardList
    }),
    defaultBankcard () {
      for (let item of this.bankcardList) {
        if (item && !item.invalid) {
          return item
        }
      }
      return {}
    },
    needSms () {
      let flag = true
      for (let item of this.bankcardList) {
        if (
          !item.invalid &&
          item.bankCardNo === this.form.bankcardNo &&
          item.bankMobile === this.form.bankMobile
        ) {
          flag = false
        }
      }
      return flag
    },
    smsTips () {
      return `
      <span>您正在绑定银行卡，绑卡验证短信已发送您的手机<em>${this.formatMobile(
        this.bankMobile
      )}</em>，请注意查收</span>
      <div style="margin-top: 20px">服务过程中，可能存在多次绑卡短信验证，请知悉 </div>
      `
    }
  },
  beforeRouteEnter (from, to, next) {
    next((vm) => {
      vm.$bus.$emit('ready')
    })
  },
  watch: {
    smsVisible (value) {
      this.$report({
        id: 50012,
        args: {
          visible: value ? 1 : 0,
          status: this.plan
        }
      })
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfoX']),
    ...mapActions('bankcard', [
      'bindBankcardApplyX',
      'bindBankcardConfirmX',
      'getBankcardListX',
      'useCouponX'
    ]),
    ...mapActions('activities', ['useCouponX']),

    async getBankCardList () {
      await this.getBankcardListX({
        loanPlatform: this.loanPlatform,
        fundCode: this.fundCode
      })
    },
    modifyMobile () {
      this.isUpdateModePhone = true
      this.isUpdateMode = false
      this.$refs['mobile'].focus()
    },

    // 倒计时结束可再次发送验证码
    countEnd () {
      this.canSendSms = true
    },

    async next () {
      this.$report({
        id: 50011,
        args: { status: this.plan }
      })
      if (this.needSms) {
        if (this.form.bankMobile !== this.showMobile) {
          this.canSendSms = true
        }
        this.errorTip = ''
        this.bankMobile = this.form.bankMobile
        if (!this.canSendSms) {
          this.smsVisible = true
          return
        }
        try {
          await this.bindBankcardApply()
          this.canSendSms = false
          this.smsVisible = true
          this.showMobile = this.form.bankMobile
        } catch (exp) {
          this.$message(exp.message)
        }
      } else {
        const res = await this.useCouponX({
          couponRecordId: this.couponRecordId,
          bankCardNo: this.form.bankcardNo
        })
        if (res.success) {
          this.$router.back()
        }
      }
    },

    // 申请绑卡
    async bindBankcardApply () {
      this.bankMobile = this.form.bankMobile
      const response = await this.bindBankcardApplyX({
        loanPlatform: this.loanPlatform,
        bankCardNo: this.form.bankcardNo,
        fundCode: this.fundCode,
        bankMobile: this.form.bankMobile,
        orderId: this.$route.query.orderId
      })
      if (response.success) {
        this.smsKey = response.data.smsKey
        return true
      } else {
        if (response.code === '000028') {
          this.smsVisible = true
          this.canSendSms = false
          this.smsKey = response.msg
        } else if (response.code === 'TMD073') {
          // 增加异常码(TMD073)该卡已绑定长银消金
          this.$message(response.msg)
          this.$router.go(-1)
        } else {
          throw new Error(response.msg)
        }
      }
    },

    // 点击重新发送验证，reset可以重置弹出框倒计时状态
    async sendSmsAgain (reset) {
      this.errorTip = ''
      try {
        await this.bindBankcardApply()
        this.canSendSms = false
        reset()
      } catch (exp) {
        this.$message(exp.message)
      }
    },

    // 点击确认绑卡后把输入的验证码回传回来
    async confirmBind (code) {
      this.$report({
        id: 50014,
        args: {
          status: this.plan,
          target: this.bankcardList.filter(item => item.bankCardNo === this.form.bankcardNo)[0] ? 0 : 1
        }
      })
      this.$report({
        id: 50015,
        args: {
          status: this.plan,
          target: this.bankcardList.filter(item => item.mobile === this.form.mobile)[0] ? 0 : 1
        }
      })
      const response = await this.bindBankcardConfirmX({
        smsKey: this.smsKey,
        loanPlatform: this.loanPlatform,
        smsCode: code,
        productCd: this.productCd
      })
      if (response.success) {
        this.smsVisible = false
        const res = await this.useCouponX({
          couponRecordId: this.couponRecordId,
          bankCardNo: this.form.bankcardNo
        })
        await this.getBankCardList()
        if (res.success) {
          this.$message('提现成功')
          this.$router.back()
          this.$report({
            id: 50013,
            args: {
              succeed: 1,
              status: this.plan
            }
          })
        } else {
          this.$report({
            id: 50013,
            args: {
              succeed: 0,
              status: this.plan
            }
          })
        }
      } else {
        if (response.code === '000010') {
          this.errorTip = response.msg
        }
      }
    },

    // 查看支持银行卡
    supportBank () {
      this.navigateTo(
        `/bankcard/support?loanPlatform=${this.loanPlatform}&fundCode=${this.fundCode}`
      )
    },

    // 导航
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    closeSms () {
      this.smsVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
    display: flex;
    flex-direction: column;
    .content {
        flex: 1;
        .tips {
            background-color: #fff9f1;
            padding: 40px 27px;
            font-size: 24px;
            color: rgba(255, 136, 100, 1);
            line-height: 33px;
        }
        .form {
            margin-top: 74px;
            padding: 0 50px;

            .form-item {
                margin-top: 48px;
                padding-bottom: 14px;

                &.modify {
                    .nd-input {
                        margin-right: 80px;
                        width: unset;
                    }

                    .modify-append {
                        font-size: 28px;
                        width: 70px;
                        bottom: 11px;
                        right: 0px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        position: absolute;
                        color: #8eb2d8;
                    }
                }

                &.support-bank {
                    font-size: 28px;
                    color: #4b94f0;
                }

                &.code {
                    .nd-input {
                        margin-right: 160px;
                        width: unset;
                    }
                }

                .nd-input {
                    height: 42px;
                    line-height: 42px;
                    margin-bottom: 8px;
                }

                .send-code {
                    width: 150px;
                    border-radius: 28px;
                    bottom: 8px;
                    right: 0px;
                    position: absolute;

                    span {
                        display: inline-block;
                        font-size: 22px;
                    }
                }
            }
        }
        .support {
            padding: 0 50px;
            display: flex;
            align-items: center;
            margin-top: 88px;
            font-size: 26px;
            color: rgba(142, 178, 216, 1);
            > img {
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
    }

    .btn {
        display: block;
        width: 650px;
        margin: 0 auto 90px;
    }
}
</style>
